import { Filter } from '../common/filter';
import { HddUsageModalController } from '../admin/hdd-usage-modal.component';
import { DatabaseUsageModalController } from '../admin/database-usage-modal.component';

require('./footer.component.scss');

class FooterController {
  constructor(
    $scope,
    CurrentFilterService,
    CurrentModelService,
    $rootScope,
    PermissionService,
    RouterService,
    FiltersService,
    CurrentFilterDataService,
    $modal,
    CancelersService,
    AggregateDataService,
    ServerInformationService,
  ) {
    this.$scope = $scope;
    this.currentFilter = CurrentFilterService;
    this.filterBar = CurrentFilterService.filterBar;
    this.CurrentModelService = CurrentModelService;
    this.$rootScope = $rootScope;
    this.permission = PermissionService;
    this.router = RouterService;
    this.FiltersService = FiltersService;
    this.CurrentFilterDataService = CurrentFilterDataService;
    this.CancelersService = CancelersService;
    this.locLabel = Filter.locLabel;
    this.AggregateDataService = AggregateDataService;
    this.ServerInformationService = ServerInformationService;
    this.$modal = $modal;
  }

  get model() {
    return this.CurrentModelService.model;
  }

  get filter() {
    return this.currentFilter.filter;
  }

  get hddUsage() {
    return this.ServerInformationService.hddUsage;
  }

  get hddAlarm() {
    return this.ServerInformationService.hddAlarm;
  }

  get databaseAlarm() {
    return this.ServerInformationService.databaseAlarm;
  }

  set filter(filter) {
    this.currentFilter.filter = filter;
  }

  get isLoading() {
    return this.CurrentModelService.loading ||
      this.CurrentFilterDataService.filterData.loading ||
      this.CurrentFilterDataService.filterData.loadingMore ||
      this.AggregateDataService.loading ||
      this.AggregateDataService.loadingMore ||
      this.FiltersService.loading;
  }

  get databaseUsage() {
    return this.ServerInformationService.databaseUsage;
  }

  reload() {
    this.$rootScope.$broadcast('reload');
  }

  cancel() {
    this.AggregateDataService.cancel();
    this.CurrentFilterDataService.filterData.cancel();
  }

  hddStatus() {
    this.$modal.open({
      template: require('../admin/hdd-usage-modal.component.html'),
      controller : HddUsageModalController,
    })
      .result
      .then(result => {
        //console.log(result);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  databaseStatus() {
    this.$modal.open({
      template: require('../admin/database-usage-modal.component.html'),
      controller : DatabaseUsageModalController,
    })
      .result
      .then(result => {
        //console.log(result);
      })
      .catch((err) => {
        console.error(err);
      });
  }
}

export const FooterComponent = {
  template  : require('./footer.component.html'),
  controller: FooterController,
};



// WEBPACK FOOTER //
// ./src/layout/footer.component.js